import React, { useContext } from "react"
import SVG from "react-inlinesvg"
import PropTypes from "prop-types"
import moment from "moment-timezone"
import priceRange from "../../../utils/priceRange"
import isOnDemand from "../../../utils/isOnDemand"
import useOptimizedImages from "../../../utils/useOptimizedImages"
import { SpaceProfileContext } from "../context"
import isDd from "../../../utils/isDd" // const replace = "https://s3-us-west-2.amazonaws.com/images.worksimply.ca"

// const replace = "https://s3-us-west-2.amazonaws.com/images.worksimply.ca"

const Floor = ({
  svg,
  bg,
  spaces = [],
  bundle = false,
  optionStart = 0,
  user = {},
  optionText = false,
  selectedBlockClassName = "",
  forPdf = false,
}) => {
  const {
    commonData: { days, spaceSummary, isDaily, displayPrice = false, teamSize },
  } = useContext(SpaceProfileContext)

  const customImage = useOptimizedImages(bg, 1200, 1200, 1200, 1200)
  const floorBG = typeof window !== "undefined" && forPdf ? customImage : bg
  let selectedCount = optionStart

  const isDedicatedDesk = isDd(spaceSummary.space_type)

  return (
    <>
      <div className="space-layout-wrapper">
        <div className={"row"}>
          <div className={forPdf ? "col-3" : "col-md-12"}>
            <ul className={`option-list ${forPdf ? "" : "for-display"}`}>
              {spaces.map((item, idx) => {
                return (
                  <li
                    key={idx}
                    className={`${
                      forPdf ? "for-pdf" : "display-styles"
                    } option-${optionStart + idx + 1}`}
                  >
                    <div>
                      <span className="box" />
                    </div>
                    <div className={"option-desc-container"}>
                      {optionText && (
                        <>
                          {forPdf ? (
                            <span className={"option-text mb-0"}>
                              <small>Selected Option</small>
                            </span>
                          ) : (
                            <span className={"option-text mb-1 mt-1"}>
                              Option {optionStart + idx + 1}
                            </span>
                          )}
                        </>
                      )}
                      {isDedicatedDesk && (
                        <span className={"main"}>
                          {`${teamSize} dedicated desk${
                            Number(teamSize) > 1 ? "s" : ""
                          }`}
                        </span>
                      )}
                      {isDedicatedDesk && item.price_per_desk && (
                        <span className={"main"}>
                          <strong>
                            ${item.price_per_desk.toLocaleString("en")}
                          </strong>
                          /desk
                        </span>
                      )}

                      {isOnDemand() || displayPrice ? (
                        <span className={isDedicatedDesk ? "" : "main"}>
                          {isDedicatedDesk ? (
                            "$" +
                            (
                              item.price_per_desk *
                              Number(spaceSummary.su_current_staff || teamSize)
                            ).toLocaleString("en")
                          ) : (
                            <strong>
                              {isOnDemand()
                                ? `$${
                                    !isDaily
                                      ? Number(
                                          item.price_per_hour
                                        ).toLocaleString("en")
                                      : Number(
                                          item.price_per_day
                                        ).toLocaleString("en")
                                  }`
                                : priceRange(item)}
                            </strong>
                          )}
                          {isOnDemand()
                            ? !isDaily
                              ? "/hour"
                              : "/day"
                            : isDedicatedDesk
                              ? " total"
                              : "/month"}
                        </span>
                      ) : (
                        ""
                      )}

                      {!isOnDemand() && !displayPrice && (
                        <span>Contact for pricing</span>
                      )}

                      {isOnDemand() && days > 1 ? (
                        <>
                          <small>
                            <strong>
                              $
                              {Number(
                                isDaily
                                  ? item.price_per_day * days
                                  : item.price_per_hour * days
                              ).toLocaleString("en")}{" "}
                              Total
                            </strong>
                          </small>
                        </>
                      ) : (
                        ""
                      )}
                      {item.max_capacity && (
                        <span>
                          {item.max_capacity === 1
                            ? "1 person"
                            : `Up to ${item.max_capacity} people`}
                        </span>
                      )}
                      {bundle && item.desks_available && (
                        <span>{item.desks_available} desks available</span>
                      )}
                      {!bundle &&
                        !item.space_available &&
                        moment(item.space_available_from).isValid() &&
                        moment(item.space_available_from).isAfter(moment()) && (
                          <span>
                            Available{" "}
                            {moment(item.space_available_from).format(
                              "MMMM Do"
                            )}
                          </span>
                        )}
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
          <div className={forPdf ? "col-9" : "col-md-12"}>
            <div className="space-layout">
              <img src={floorBG} alt="" />
              <SVG
                src={`${
                  process.env.GATSBY_SERVER_URL
                }/upload/getSvg?url=${encodeURIComponent(svg)}`}
                onLoad={() => {
                  const indexedSvgs = {}
                  const allSvgElements =
                    document.querySelectorAll("svg path, svg rect")

                  for (let j = 0; j < spaces.length; j++) {
                    const selectedSpace = spaces[j]

                    for (
                      let index = 0;
                      index < allSvgElements.length;
                      index++
                    ) {
                      const element = allSvgElements[index]
                      const svgId = getIdentifierFromSvg(element)

                      indexedSvgs[svgId] = element
                      element.setAttribute("fill", "transparent")
                      element.setAttribute("stroke", "transparent")

                      if (
                        selectedSpace &&
                        selectedSpace.svg_identifier === svgId
                      ) {
                        element.setAttribute("fill-opacity", 1)
                        if (forPdf) {
                          element.setAttribute("fill", "#478261")
                          element.setAttribute(
                            "class",
                            `active color-${selectedCount++} ${selectedBlockClassName}`
                          )
                        } else {
                          element.setAttribute(
                            "class",
                            `active animate color-${selectedCount++} ${selectedBlockClassName}`
                          )
                        }
                      }
                    }
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

Floor.propTypes = {
  svg: PropTypes.string,
  bg: PropTypes.string,
  spaces: PropTypes.array,
  bundle: PropTypes.bool,
  handleModal: PropTypes.func,
  optionStart: PropTypes.number,
}

export default Floor

const getIdentifierFromSvg = (element) => {
  let whitelistedAttributes = []
  let identifier = []
  switch (element.tagName) {
    case "rect":
      whitelistedAttributes = ["width", "x", "y", "height"]
      break
    case "path":
      whitelistedAttributes = ["d"]
      break
    default:
      break
  }

  for (let i = 0; i < element.attributes.length; i++) {
    for (let j = 0; j < whitelistedAttributes.length; j++) {
      if (element.attributes[i].nodeName === whitelistedAttributes[j]) {
        identifier.push(
          whitelistedAttributes[j] + ":" + element.attributes[i].nodeValue
        )
      }
    }
  }

  return identifier.join("|")
}
